$(".slide-marcas").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    arrows: false,
    // centerMode: true,
    // variableWidth: true,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
          }
        }
    ]
});

if ($('.segments-banner').length) {
  $('.segments-banner').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    fade: true,
    autoplay: true,
    cssEase: 'ease-in-out'
  });
}